import React from 'react';
import { FaStar, FaTrash } from 'react-icons/fa6';
import BreadcrumbsContainer from '../Breadcrumbs/BreadcrumbContainer';
import ActionButton from '../Buttons/ActionButton';
import { useDispatch, useSelector } from 'react-redux';
import { useDeleteProjectMutation } from '../../api/project';
import { useStarEntityMutation } from '../../api/favorite';
import { clearSelectedProjectIds, selectSelectedProjectIds } from '../../Store/projectSlice';

interface ProjectActionButtonsProps {

}

export default function ProjectActionButtons(props: ProjectActionButtonsProps) {

    const selectedProjectIds = useSelector(selectSelectedProjectIds);
    const [ deleteProject, { isLoading: projectDeleteLoading, isError: projectDeleteError, isSuccess: projectDeleteSuccess }] = useDeleteProjectMutation();
    const [ starEntity, { isLoading: starLoading }] = useStarEntityMutation();
    const dispatch = useDispatch();

    const handleFavoriteClick = async () => {
        if (!selectedProjectIds.length) return;
        for (let i = 0; i < selectedProjectIds.length; i++) {
            try {
                await starEntity({ entityId: selectedProjectIds[i], entityType: 'Project' }).unwrap();
            } catch (error) {
                console.log("error starring project", error);
            }
        }
        dispatch(clearSelectedProjectIds());
    }

    const handleDeleteClick = async () => {
        if (!selectedProjectIds.length) return;
        try{
            for(let i = 0; i < selectedProjectIds.length; i++){
                console.log("deleting project", selectedProjectIds[i])
                await deleteProject(selectedProjectIds[i]).unwrap();
                console.log("project deleted", selectedProjectIds[i])
            }
        }catch(error){
            console.log("error deleting project", error);
        }
        // deleteProject invalidates the 'Project' tag → list refetches automatically
        dispatch(clearSelectedProjectIds())
    }

    return (
        <BreadcrumbsContainer>
            <ActionButton text='Move to trash' Icon={FaTrash} onClick={handleDeleteClick} loading={projectDeleteLoading}/>
            <ActionButton text='Add to favorite' Icon={FaStar} onClick={handleFavoriteClick} loading={starLoading}/>
        </BreadcrumbsContainer>
    )
}